import moment from 'moment';
import { CustomNotification } from '../../../../../v2-components/Notification';
import { Notification } from '../../../../../v2-components/Notification/constant';

export const isValidDateRange = (fromDate, toDate) => {
  const from = moment(fromDate, 'DD/MM/YY');
  const to = moment(toDate, 'DD/MM/YY');

  if (from.isAfter(to)) {
    CustomNotification({
            type: Notification.type.error,
            message: Notification.message.error,
            description: 'La fecha "Desde" no puede ser posterior a la fecha "Hasta".',
    });
    return false; 
  }

  return true;
};
